<template>
    <div class="pdf__wrapper container" id="ref">
        <div class="gen" :class="generationIndex">{{$t('Global.PDF.Headline')}}
            <div class="mt-4">{{$t('Global.PDF.Page')}} {{generationIndex}} / {{maxGenerationIndex}} {{$t('Global.PDF.Created')}}</div>
        </div>
        <div class="merkliste__wrapper">
            <div class="merkliste__item" :class="'merkliste__item-'+index" v-for="(Angebot, index ) in Angebote" >
                <h2>{{$t('Angebot.PDFHeadline')}} {{index +1}}: </h2>
                <div class="merklisten__item-chapter mb-3">
                    <h3>{{$t('Angebot.Allgemein')}}:</h3>
                    <ul>
                    <p>{{$t('Angebot.Zimmerart')}}: <span v-for="art in arten" ><span v-if="art.value == Angebot.zimmerart">{{ art.text}}</span></span></p>
                    <p class="">{{$t('Angebot.Groeß')}}: {{ Angebot.zimmergroesse }}m²</p>
                    <p class="" v-if="Angebot.etage && Angebot.etage != ''">{{$t('Angebot.Etage')}}:
                        <span  v-for="a in etage">
                          <template v-if="Angebot.etage && Angebot.etage.indexOf(a.value) >= 0">
                               <span v-if="Angebot.etage == 'stockwerk'">{{Angebot.stockwerk}}. {{ a.text}}</span>
                               <span v-else>{{ a.text}}</span>
                          </template>

                      </span>
                    </p>
                    <p class="">{{$t('Angebot.Ort')}}: {{ Angebot.ort }}</p>
                    <p class="" v-if="Angebot.freiab && Angebot.freiab != '0000-00-00 00:00:00'">{{$t('Angebot.Freiab')}}: {{ Angebot.freiab}}</p>
                    <p class="" v-if="Angebot.freibis && Angebot.freibis != '0000-00-00 00:00:00'">{{$t('Angebot.Freibis')}}: {{ Angebot.freibis}}</p>
                    <p class="" v-if="Angebot.minimalemietdauer">{{$t('Angebot.Mindauer')}}: {{ Angebot.minimalemietdauer }}</p>
                      <p class="" v-if="Angebot.bemerkungen">{{$t('Angebot.Bemerkung')}}: {{ Angebot.bemerkungen}}</p>
                    </ul>
                </div>
                <div class="merklisten__item-chapter mb-3" v-if="Angebot.ausstattungkueche || Angebot.ausstattungbad || Angebot.ausstattungSonstiges">
                    <h3 class="underline">{{$t('Angebot.Ausstattung')}}:</h3>
                    <ul>
                    <p class="font-weight-bold" v-if="Angebot.ausstattungkueche && Angebot.ausstattungkueche != ''">{{$t('Angebot.Kuche')}}:</p>
                    <div  v-for="a in ausstattungKueche">
                        <p v-if="Angebot.ausstattungkueche && Angebot.ausstattungkueche.indexOf(a.value) >= 0" class="">{{ a.text}}</p>
                    </div>
                    <p class="font-weight-bold" v-if="Angebot.ausstattungbad  && Angebot.ausstattungbad != ''">{{$t('Angebot.Bad')}}:</p>
                    <div v-for="a in ausstattungBad">
                        <p v-if="Angebot.ausstattungbad && Angebot.ausstattungbad.indexOf(a.value) >= 0" class="">{{ a.text}}</p>
                    </div>
                    <p class="font-weight-bold" v-if="Angebot.ausstattungsonstiges && Angebot.ausstattungsonstiges != ''">{{$t('Angebot.Sonstige')}}:</p>
                    <div  v-for="a in ausstattungSonstiges">
                        <p v-if="Angebot.ausstattungsonstiges && Angebot.ausstattungsonstiges.indexOf(a.value) >= 0" class="">{{ a.text}}</p>
                    </div>

                    <div  v-for="a in zusatz">
                        <p v-if=" Angebot.zimmerzusatzinformationen && Angebot.zimmerzusatzinformationen.indexOf(a.value) >= 0" class="">{{ a.text}}</p>
                    </div>
                    </ul>
                </div>
                <div class="merklisten__item-chapter mb-3">
                    <h3>{{$t('Angebot.Kosten')}}:</h3>
                    <ul class="list-group">
                        <p class="">{{$t('Angebot.Miete')}}: {{ Angebot.miete }}</p>
                        <p class="" v-if="Angebot.nebenkostenart">{{$t('Angebot.Nebenkosten')}}: {{ Angebot.nebenkosten}}</p>
                        <p class="" v-if="Angebot.nebenkostenart">{{$t('Angebot.Nebenkostenart')}}: <span v-for="art in nebenkostenArten" ><span v-if="art.value == Angebot.nebenkostenart">{{ art.text}}</span></span></p>
                        <p class="">{{$t('Angebot.Kaution')}}: {{ Angebot.kaution }}</p>
                    </ul>
                </div>
                <div class="merklisten__item-chapter mb-3">
                    <h3>{{$t('Angebot.Ansprechpartner')}}:</h3>
                    <ul class="list-group">
                        <p class="" v-if="Angebot.showname == 1 && Angebot.name">{{$t('Angebot.Name')}}: {{ Angebot.name }}</p>
                        <p class="" v-if="Angebot.showtelefon == 1 && Angebot.telefon">{{$t('Angebot.Tele')}}: {{ Angebot.telefon }}</p>
                        <p class="" v-if="Angebot.showmobil == 1 && Angebot.mobil">{{$t('Angebot.Handy')}}: {{ Angebot.mobil }}</p>
                        <p class="" v-if="Angebot.showemail == 1 && Angebot.email" >{{$t('Angebot.Email')}}: {{ Angebot.email }}</p>

                    </ul>
                </div>
              <div class="merklisten__item-chapter mb-3">
                <h3>{{$t('Angebot.Lage')}}:</h3>
                <ul class="list-group">
                  <p class="" v-if="Angebot.verkehrsanbindung && Angebot.verkehrsanbindung.length != 0">{{$t('Angebot.Erreichbar')}}:
                    <span v-bind:key="a.value" v-for="(a, index) in Angebot.verkehrsanbindung">

                     <span v-if="index != Angebot.verkehrsanbindung.length -1">{{findByValue(verkehrsanbindung, a)}}, </span>
                    <span v-else>{{findByValue(verkehrsanbindung, a)}}</span>

                  </span>
                  </p>
                  <p class="" v-if="Angebot.entfernung">{{$t('Angebot.Entfernung')}}: {{ Angebot.entfernung }}</p>

                </ul>
              </div>
                <div class="merklisten__item-chapter ">
                    <h3>{{$t('Angebot.Personenkreis')}}:</h3>
                    <p class="" v-if="Angebot.mietergeschlecht && Angebot.mietergeschlecht != 'e' ">
                        {{$t('Angebot.Geschlecht')}}
                        <span v-if="Angebot.mietergeschlecht == 'm'">{{$t('Angebot.Geschlechts.Maennlich')}}</span>
                        <span v-else-if="Angebot.mietergeschlecht == 'w'">{{$t('Angebot.Geschlechts.Weiblich')}}</span>
                        <span v-else-if="Angebot.mietergeschlecht == 'e'">{{$t('Angebot.Geschlechts.Egal')}}</span>
                    </p>
                    <p class="" v-if="Angebot.mieterraucher">{{$t('Angebot.Raucher')}} <span v-if="Angebot.mieterraucher == 1">{{$t('Global.Ja')}}</span><span v-else>{{$t('Global.Nein')}}</span></p>
                    <p class=" text-capitalize" v-if="Angebot.mieterbevorzugt">
                        {{$t('Angebot.Bevorzugt')}}:
                        <span  v-for="(a, index) in Angebot.mieterbevorzugt">
                            <span v-if="index != Angebot.mieterbevorzugt.length -1">{{findByValue(bevorzugte, a)}}, </span>
                            <span v-else>{{findByValue(bevorzugte, a)}}</span>
                        </span>
                    </p>

                </div>


            </div>
        </div>
        <div id="copy">

        </div>
    </div>
</template>

<script>
    import jsPDF from 'jspdf'
    //import html2canvas from "html2canvas"
    import settings from '@/components/Settings.json';
    export default {
        name: "PDF",
        props:{
            Angebote: Array,
        },
        data() {
            return {
                arten: [],
                nebenkostenArten: [],
                ausstattungBad: [],
                ausstattungKueche: [],
                ausstattungSonstiges: [],
                etage: [],
                zusatz: [],
                bevorzugte: [],
                verkehrsanbindung: [],
                generationIndex: 1,
                maxGenerationIndex: Number,
            };
        },
        beforeMount(){

        },
        mounted() {
            let sites = document.querySelectorAll(".merkliste__item");
            this.maxGenerationIndex = sites.length;
            let _this = this;
            this.arten = settings.Settings[1][this.$store.getters.lang][0].Zimmerarten;
            this.nebenkostenArten = settings.Settings[1][this.$store.getters.lang][0].nebenkostenArten;
            this.ausstattungBad = settings.Settings[1][this.$store.getters.lang][0].ausstattungBad;
            this.ausstattungKueche = settings.Settings[1][this.$store.getters.lang][0].ausstattungKueche;
            this.ausstattungSonstiges = settings.Settings[1][this.$store.getters.lang][0].ausstattungSonstiges;
            this.etage = settings.Settings[1][this.$store.getters.lang][0].etage;
            this.zusatz = settings.Settings[1][this.$store.getters.lang][0].zusatz;
            this.verkehrsanbindung = settings.Settings[1][this.$store.getters.lang][0].anbindung;
            this.bevorzugte = settings.Settings[1][this.$store.getters.lang][0].Bevorzugte;
            setTimeout(function(){
                _this.createPdf();
            }, 250);

        },
        methods: {
            findByValue(source, val) {
                for (var i = 0; i < source.length; i++) {
                    if (source[i].value === val) {
                        return source[i].text;
                    }
                }
                throw "Couldn't find object with val: " + val;
            },
            createPdf(){
                const doc = new jsPDF('p','pt','a4');
                //let canvasEl = document.querySelector("#ref")
                let sites = document.querySelectorAll(".merkliste__item");
                //var width = doc.internal.pageSize.getWidth();
                //var height = doc.internal.pageSize.getHeight();
                //var doc = new jsPDF();
                console.log("PDF:", doc)

                for(let i = 0; i < sites.length; i++){
                    this.generationIndex = i;

                    let item = document.querySelector('.merkliste__item-'+i);
                    if(i != 0){
                        doc.addPage();
                    }
                    doc.fromHTML(item, 15, 15);
                    if(i == sites.length -1){
                        doc.save("Merklisten-PDF.pdf");

                        this.$router.push('/angebote/merkliste')
                    }

                }
            }
        }
    }
</script>

<style scoped>
    .gen{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: white;
        color: black;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .merkliste__item h2 {
        color: black;
        text-align: left;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
    }
    .merkliste__item h3 {
        color: black;
        text-align: left;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
    }
    .merkliste__item p {
        color: black;
        text-align: left;
        margin-bottom: 5px;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
    }
    .merkliste__item li {
        color: black;
        text-align: left;
        margin-bottom: 5px;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
    }
    .merkliste__item ul {
        list-style: none;
        padding-left: 0px;
    }
    .merkliste__item {
        /*width: 210mm;*/
        min-height: 290mm;
        height: 100%;
    }
    .list-group{
        text-align: left;
    }
    #copy{
        width: 21cm;
        height: 29.7cm;

    }
    h2{
        font-size: 18px;
        font-weight: bold;
    }
    h3{
        font-size: 15px;
        font-weight: bold;
    }
    ul{
        list-style: none;
        padding-left: 0px;
    }
    p, li{
        font-size: 12px;
    }
</style>